import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { Psm } from '../../styles/2024/TextStyles'

const END_DATE_COUNTDOWN = '05/01/2024'

export default function Countdown() {
  const endDay = dayjs(END_DATE_COUNTDOWN, 'MM/DD/YYYY')
  const [daysLeft, setDaysLeft] = useState(() =>
    endDay.diff(dayjs(), 'days') > 0 ? endDay.diff(dayjs(), 'days') : 0,
  )
  const [hoursLeft, setHoursLeft] = useState(() =>
    endDay.diff(dayjs(), 'hours') % 24 > 0 ? endDay.diff(dayjs(), 'hours') % 24 : 0,
  )
  const [minutesLeft, setMinutesLeft] = useState(() =>
    endDay.diff(dayjs(), 'minutes') % 60 > 0 ? endDay.diff(dayjs(), 'minutes') % 60 : 0,
  )

  // Update the time left every 10 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = dayjs()
      const updatedDaysLeft = endDay.diff(now, 'days')
      const updatedHoursLeft = endDay.diff(now, 'hours') % 24
      const updatedMinutesLeft = endDay.diff(now, 'minutes') % 60

      setDaysLeft(updatedDaysLeft > 0 ? updatedDaysLeft : 0)
      setHoursLeft(updatedHoursLeft > 0 ? updatedHoursLeft : 0)
      setMinutesLeft(updatedMinutesLeft > 0 ? updatedMinutesLeft : 0)
    }, 10000) // Update every 10 seconds

    // Cleanup on component unmount
    return () => clearInterval(intervalId)
  }, [endDay])

  return (
    <div className='flex flex-col align-center justify-around py-4'>
      <Psm className='text-beige-yellow text-center m-0'>May 1-2 YES! Public Exhibition</Psm>
      <Psm className='text-beige-yellow text-center'>
        <span className='text-comfort-green'>{daysLeft > 10 ? daysLeft : '0' + daysLeft}</span> days
        <span className='text-comfort-green'>
          {' '}
          {hoursLeft >= 10 ? hoursLeft : '0' + hoursLeft}
        </span>{' '}
        hours
        <span className='text-comfort-green'>
          {' '}
          {minutesLeft >= 10 ? minutesLeft : '0' + minutesLeft}
        </span>{' '}
        minutes until the show
      </Psm>
    </div>
  )
}
